import { request } from './api'

import { home, addNotification, redirect } from './'
import { SET_MAINTENANCE_INFO } from '../constants/actions'

export function updateSubscriber(subscriber) {
    subscriber = { ...subscriber, activeCall: undefined }
    return (dispatch) => {
        dispatch(request(`subscribers/${subscriber.username}`, { method: 'PUT', data: subscriber }))
            .then(response => dispatch({
                type: 'REPLACE_SUBSCRIBER',
                subscriber: response
            }))
            .then(() => dispatch(addNotification('success', 'Subscriber successfully saved.')))
    }
}

export function addSubscriber(subscriber) {
    return dispatch => dispatch(request('subscribers', { method: 'POST', data: subscriber }))
        .then(response => dispatch({
            type: 'ADD_SUBSCRIBER',
            subscriber: response
        }))
        .then(() => dispatch(addNotification('success', 'Subscriber successfully saved.')))
        .then(() => dispatch(redirect(redirect(`/edit/${subscriber.username}`))))
}

export function deleteSubscriber(subscriber) {
    return dispatch => dispatch(request(`subscribers/${subscriber.username}`, { method: 'DELETE' }))
        .then(() => {
            dispatch({
                type: 'REMOVE_SUBSCRIBER',
                subscriber
            })
            dispatch(home())
        })
}

export function setMaintenanceInfo(text) {
    return dispatch => dispatch(request('/maintenance', {
        method: text ? 'POST' : 'DELETE',
        data: text
    })).then(maintenanceInfo => dispatch({
        type: SET_MAINTENANCE_INFO,
        maintenanceInfo: text ? maintenanceInfo : null
    }))
}


// WEBPACK FOOTER //
// ./actions/admin.js